import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CoreModule } from 'app/modules/core.module';
import { InsuredService } from '@services/insured.service';
import { StateDisplayComponent } from 'app/shared/state-display/state-display.component';

@Component({
  selector: 'app-bank-account-view',
  standalone: true,
  imports: [CoreModule, StateDisplayComponent],
  providers: [InsuredService],
  templateUrl: './bank-account-view.component.html',
  styleUrls: ['./bank-account-view.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BankAccountViewComponent implements OnInit {
  @Input() insuredId: string

  private _insuredService = inject(InsuredService)
  private destroyRef = inject(DestroyRef)
  private cdr = inject(ChangeDetectorRef)
  protected account: any
  protected showSpinner = true

  ngOnInit(): void {
    if (this.insuredId) this.getBankAccount()
    else this.showSpinner = false
  }

  getBankAccount(): void {
    this._insuredService.getBankAccount(this.insuredId).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
      this.account = res
      this.showSpinner = false
      this.cdr.markForCheck()
    })
  }
}
